import * as React from 'react';
import DataGrid from '../../../hiberUiKit/src/organisms/DataGrid/DataGrid';
import JobType from "../../../model/job/JobType";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import Loading from "../../ui/loading/Loading";

interface ComponentProps {
	/**
	 * Product packages
	 */
	jobTypes: JobType[];
	/**
	 * Row click callback
	 */
	onRowClick: (jobType: JobType) => void;
	/**
	 * All activity templates as a map
	 */
	activityTemplatesMap: { [key: string]: DictionaryItem };
}

type Props = ComponentProps;

export default class JobTypesTable extends React.Component<Props> {

	render() {
		return (

				<DataGrid hasPointer hasHover>
					<thead>
					<tr>
						<th>Id</th>
						<th>Name</th>
						<th>Activity template</th>
						<th>Labour only</th>
						<th>Fee</th>
						<th style={{width: "10%"}}>Status</th>
					</tr>
					</thead>
					<tbody>
					{this.props.jobTypes.map((item, index) => (
						<tr key={index} onClick={() => this.props.onRowClick(item)}>
							<td>{item.id}</td>
							<td>{item.name}</td>
							<td>{item.activityTemplateId.map(id =>
								this.props.activityTemplatesMap[id] ?
									this.props.activityTemplatesMap[id].name : <Loading isLoading={!this.props.activityTemplatesMap[id]} />
							).getOrElse("not set")}</td>
							<td>{item.labourOnly ? "Yes" : "No"}</td>
							<td>{item.fee}</td>
							<td>{item.active ? "Enabled" : "Disabled"}</td>
						</tr>
					))}
					</tbody>
				</DataGrid>
		)
	}
}
